export const POPULAR_SLOTS = 3;
export const POPULAR_CANDIDATES = 12;

export const selectPopularProducts = (
  topSellerIds,
  products,
  { headIdFor = id => id, isSellable = p => p.stock == null || p.stock > 0 } = {},
) => [...new Set(topSellerIds.map(headIdFor))]
  .map(id => products.find(p => p.id === id))
  .filter(p => p && isSellable(p))
  .slice(0, POPULAR_SLOTS);
